module.exports = __webpack_public_path__ + "img/bu4.10186c32.png";